<template>
  <div class="page-sem">
    <NavBar active-menu="sem"></NavBar>
    <SearchSem></SearchSem>
  </div>
</template>

<script>
import NavBar from '../components/NavBar.vue';
import SearchSem from '../components/SearchSem.vue';
export default {
  components: {
    NavBar,
    SearchSem,
  },
};
</script>
